/**
 * @generated SignedSource<<66789805880df0a0bcdc594422521efc>>
 * @relayHash d5bf5df01eff840f9b29492824ebb770
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f2dbcd4c020f3063655a22a146ec1e45596f5206fe356d3370930377f841e1ab

import type { ConcreteRequest } from 'relay-runtime';
export type CompanyHubAnnouncementBannerQuery$variables = {
  keys: ReadonlyArray<string | null | undefined>;
  pageId: string;
};
export type CompanyHubAnnouncementBannerQuery$data = {
  readonly confluence: {
    readonly page: {
      readonly id: string;
      readonly properties: ReadonlyArray<{
        readonly id: string | null | undefined;
        readonly key: string;
        readonly value: string;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type CompanyHubAnnouncementBannerQuery = {
  response: CompanyHubAnnouncementBannerQuery$data;
  variables: CompanyHubAnnouncementBannerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "keys"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageId"
},
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = [
  {
    "concreteType": "ConfluenceQueryApi",
    "kind": "LinkedField",
    "name": "confluence",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "pageId"
          }
        ],
        "concreteType": "ConfluencePage",
        "kind": "LinkedField",
        "name": "page",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": [
              {
                "kind": "Variable",
                "name": "keys",
                "variableName": "keys"
              }
            ],
            "concreteType": "ConfluencePageProperty",
            "kind": "LinkedField",
            "name": "properties",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "key"
              },
              {
                "kind": "ScalarField",
                "name": "value"
              },
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "CompanyHubAnnouncementBannerQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CompanyHubAnnouncementBannerQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "d5bf5df01eff840f9b29492824ebb770",
    "id": "f2dbcd4c020f3063655a22a146ec1e45596f5206fe356d3370930377f841e1ab",
    "metadata": {},
    "name": "CompanyHubAnnouncementBannerQuery",
    "operationKind": "query",
    "text": "query CompanyHubAnnouncementBannerQuery($pageId:ID!,$keys:[String]!){confluence{page(id:$pageId){id,properties(keys:$keys){key,value,id}}}}"
  }
};
})();

(node as any).hash = "fbfc6dce8692747276f81029c894fe08";

export default node;
